import { useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { useConsigneeAccountInfo } from 'src/hooks/api/useConsigneeAccountInfo';

/**
 * Default currency for a purchase created under the given consignee,
 * or the current account's currency when no consignee is given.
 */
export const useGetPurchaseConsigneeCurrencyCode = () => {
  const { loginContext } = useAppContext();
  const { data: consigneeAccounts } = useConsigneeAccountInfo();

  return useCallback(
    (consigneeSellerAccountId: string | null) => {
      const ownCurrencyCode = loginContext?.user?.activeAccount?.currencyCode;
      if (!consigneeSellerAccountId) {
        return ownCurrencyCode;
      }

      return (
        consigneeAccounts?.find((a) => a.id === consigneeSellerAccountId)
          ?.currencyCode ?? ownCurrencyCode
      );
    },
    [consigneeAccounts, loginContext?.user?.activeAccount?.currencyCode]
  );
};
